import * as React from "react";

function SvgLock(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <defs>
        <clipPath id="lock_svg__prefix__clip-path">
          <path
            id="lock_svg__prefix__Ret\xE2ngulo_69"
            d="M0 0h20v20H0z"
            data-name="Ret\xE2ngulo 69"
            transform="translate(484 681)"
            fill="currentColor"
            stroke="currentColor"
          />
        </clipPath>
        <style>
          {
            ".lock_svg__prefix__cls-3{fill:currentColor;stroke:currentColor;stroke-width:.4px}"
          }
        </style>
      </defs>
      <g
        id="lock_svg__prefix__Grupo_de_m\xE1scara_5"
        data-name="Grupo de m\xE1scara 5"
        transform="translate(-484 -681)"
      >
        <g id="lock_svg__prefix__padlock" transform="translate(486.4 681.3)">
          <g id="lock_svg__prefix__Grupo_23" data-name="Grupo 23">
            <g id="lock_svg__prefix__Grupo_22" data-name="Grupo 22">
              <path
                id="lock_svg__prefix__Caminho_26"
                d="M15.351 7.05h-1.337V3.966a4.008 4.008 0 00-8.014 0V7.05H4.664A2.241 2.241 0 002.438 9.3v7.65a2.241 2.241 0 002.226 2.25h10.687a2.241 2.241 0 002.226-2.25V9.3a2.241 2.241 0 00-2.226-2.25zM7.483 3.966a2.524 2.524 0 015.047 0V7.05H7.483V3.966zm8.61 12.984a.747.747 0 01-.742.75H4.664a.747.747 0 01-.742-.75V9.3a.747.747 0 01.742-.75h10.687a.747.747 0 01.742.75z"
                className="lock_svg__prefix__cls-3"
                data-name="Caminho 26"
                transform="translate(-2.438)"
              />
            </g>
          </g>
          <g
            id="lock_svg__prefix__Grupo_25"
            data-name="Grupo 25"
            transform="translate(6.125 10.57)"
          >
            <g id="lock_svg__prefix__Grupo_24" data-name="Grupo 24">
              <path
                id="lock_svg__prefix__Caminho_27"
                d="M11.711 13.406a1.445 1.445 0 00-.783 2.66v1.715a.781.781 0 001.563 0v-1.713a1.445 1.445 0 00-.78-2.662z"
                className="lock_svg__prefix__cls-3"
                data-name="Caminho 27"
                transform="translate(-10.266 -13.406)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgLock;

